// Copyright © 2021 Move Closer

import { Component } from 'vue-property-decorator'

import { AbstractModuleUi } from '../_abstract/ui'

import { DataSetModule } from './DataSet.contracts'

/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
@Component({
  name: 'DataSetModuleUi',
  template: `
    <div class="data-set-module">
      <p v-if="module.content.dataSet['name']" class="data-set-module__title">
        <strong>{{module.content.dataSet.name}}</strong>
      </p>

      <div class="data-set-module__table-wrapper">
        <table v-if="module.content.dataSet['data']" class="data-set-module__table">
          <tr v-for="(row, rowIndex) in module.content.dataSet.data" :key="rowIndex">
            <td v-for="(col, colIndex) in row" :key="colIndex"
                class="data-set-module__table__cell" :title="col">
              {{col}}
            </td>
          </tr>
        </table>
      </div>

      <span v-if="module.content.dataSet['note']" class="data-set-module__note">
        {{module.content.dataSet.note}}
      </span>
    </div>
  `
})
export class DataSetModuleUi extends AbstractModuleUi<DataSetModule> {}
